export default "__VITE_ASSET__353a60e7__"